import styles from './index.module.scss';
import { useLang } from '@/i18n';

export default function ActivityExplain() {
    const { t } = useLang('ecocreditsday.pageTabs.tabC');

    return (
        <div className={styles.activityExplain}>
            <div className="activity-explain">
                <div className="sub-title">{t.rich('activityExplain.sub_title', { line1: (text: string) => <span className="red-color">{text}</span> })}</div>
                <div className="title">{t('activityExplain.title')}</div>
                <div className="desc">{t.rich('activityExplain.desc', { line1: (text: string) => <span className="red-color">{text}</span> })}</div>
                <div className="line"></div>
                <div className="tip">{t('activityExplain.tip')}</div>
            </div>
        </div>
    );
}
